import { Question } from "survey-core";
import { Button } from "@rumbledirect/ui";
import { createStyles } from "antd-style";
import { Typography } from "antd";

export class DocumentExampleQuestionModel extends Question {
  getType() {
    return "documentExample";
  }

  get imageUrl(): string {
    return this.getPropertyValue("imageUrl");
  }

  set imageUrl(val: string) {
    this.setPropertyValue("imageUrl", val);
  }

  get downloadUrl(): string {
    return this.getPropertyValue("downloadUrl");
  }

  set downloadUrl(val: string) {
    this.setPropertyValue("downloadUrl", val);
  }

  get downloadLabel(): string {
    return this.getPropertyValue("downloadLabel");
  }

  set downloadLabel(val: string) {
    this.setPropertyValue("downloadLabel", val);
  }
}

const useStyles = createStyles(({ css, token }) => ({
  card: css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 12px 18px;
    height: 300px;
    border: 1px solid ${token.colorBorder};
    border-radius: ${token.borderRadius}px;
    transition: border-color 0.2s;
    justify-content: space-between;

    &:hover {
      border-color: ${token.colorBorderSecondary};
    }
  `,
  title: css`
    text-align: center;
    margin: 0;
    padding: 8px;
  `,
  image: css`
    display: block;
    margin: 0 auto;
    min-height: 0;
    max-width: 70%;
    max-height: 40%;
    object-fit: contain;
  `,
  button: css`
    width: 100%;
  `,
}));

interface DocumentExampleQuestionProps {
  question: DocumentExampleQuestionModel;
}

export const DocumentExampleQuestion = ({
  question,
}: DocumentExampleQuestionProps) => {
  const { styles } = useStyles();

  if (!question.imageUrl || !question.downloadUrl || !question.downloadLabel) {
    return null;
  }

  return (
    <div className={styles.card}>
      {question.title && (
        <Typography.Title level={5} className={styles.title}>
          {question.title}
        </Typography.Title>
      )}
      <img
        alt={question.title || "Document"}
        loading="lazy"
        src={question.imageUrl}
        className={styles.image}
      />
      <Button
        type="primary"
        className={styles.button}
        href={question.downloadUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {question.downloadLabel}
      </Button>
    </div>
  );
};
